import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import type { EmailListLayoutsDynamicAttributes } from 'hb-builder/components/BuilderComponents/dynamic/EmailList/types';
import type { News } from 'hb-builder/components/BuilderComponents/dynamic/types/news';
import EmailListLoader from 'hb-builder/components/common/LoadingComponents/EmailListLoader';

import ListItem from './ListItem';

interface NewsWrapperProps {
  data: News[];
  dynamicAttributes: EmailListLayoutsDynamicAttributes;
  isLoading: boolean;
}
const NewsWrapper = ({
  data: news,
  dynamicAttributes,
  isLoading,
}: NewsWrapperProps) => {
  if (isLoading || !news) {
    return <EmailListLoader />;
  }

  return (
    <Wrapper>
      {news?.map((item) => (
        <ListItem
          dynamicAttributes={dynamicAttributes}
          key={item.id}
          {...item}
        />
      ))}
      {dynamicAttributes.button?.display && (
        <Button>
          {dynamicAttributes.button?.content || s__('Builder|See all news')}
        </Button>
      )}
    </Wrapper>
  );
};

export default NewsWrapper;

const Wrapper = styled(Box).attrs({
  alignItems: 'center',
  flexDirection: 'column',
  py: 8,
  width: '100%',
})``;
